export default __webpack_public_path__ + "static/media/banhmiyes.d2f67aa9.webp";